import { Categories } from "../types/categories";

type AdminTag = {
  id: number;
};

type CanEditRiskArgs = {
  isAdmin: boolean;
  riskTheme?: Categories;
  currentUserLogin: string;
  currentUserTags?: {
    adminTags?: AdminTag[];
  };
};

export const canEditRisk = ({
  isAdmin,
  riskTheme,
  currentUserLogin,
  currentUserTags,
}: CanEditRiskArgs) => {
  if (isAdmin) {
    return true;
  }

  if (!riskTheme || !currentUserLogin) {
    return false;
  }

  const normalizedLogin = currentUserLogin.toLowerCase();

  return (
    riskTheme.owner.login.toLowerCase() === normalizedLogin ||
    (riskTheme.managers?.some(
      (manager) => manager.login.toLowerCase() === normalizedLogin
    ) ?? false) ||
    (riskTheme.tags?.some(
      (tag) => currentUserTags?.adminTags?.some((userTag) => userTag.id === tag.id)
    ) ?? false)
  );
};